import { flexRender } from '@tanstack/react-table';
import { useMemo } from 'react';

import { CardCell, CardRow } from '../../Cards';
import { TableCell, TableRow } from '../../StyledTable';

import { DataTableRowProps } from './DataTableRow.types';

export const DataTableRow = <TData,>({
  rowStyle = 'classic',
  table,
  row,
  alternateBackgrounds,
  disableExpandOnClick,
  enableExpanding,
  enableRowSelection,
  disableSelectOnClick,
  disableRowAnimation,
  onRowClick,
  navigateTo,
}: DataTableRowProps<TData>) => {
  const to = useMemo(() => navigateTo?.(row), [navigateTo, row]);

  if (rowStyle === 'classic') {
    return (
      <>
        <TableRow
          key={row.id}
          color={
            alternateBackgrounds
              ? table
                  .getRowModel()
                  .rows.filter(row => row.depth === 0)
                  .indexOf(row.getParentRows()[0] ?? row) %
                  2 ===
                0
                ? 'white'
                : 'beige'
              : undefined
          }
          onClick={() => {
            if (!disableExpandOnClick && enableExpanding && row.getCanExpand())
              row.toggleExpanded();
            else if (!disableSelectOnClick && enableRowSelection && row.getCanSelect())
              row.toggleSelected();

            onRowClick?.(row);
          }}
          to={to}
          isSubRow={row.depth > 0}
          isClickable={
            Boolean(onRowClick) ||
            Boolean(to) ||
            (!disableSelectOnClick && enableRowSelection && row.getCanSelect()) ||
            (!disableExpandOnClick && enableExpanding && row.getCanExpand())
          }
          isSelected={row.getIsSelected() || row.getIsExpanded()}
          isCollapsed={!row.getParentRows().every(row => row.getIsExpanded())}
          data-state={row.getIsSelected() && 'selected'}
        >
          {row.getVisibleCells().map(cell => {
            return (
              <TableCell key={cell.id}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </TableCell>
            );
          })}
        </TableRow>
        {enableExpanding &&
          !disableRowAnimation &&
          table.getRowModel().flatRows.length < 200 &&
          row.subRows.map(subRow => (
            <DataTableRow
              key={subRow.id}
              rowStyle={rowStyle}
              table={table}
              row={subRow}
              alternateBackgrounds={alternateBackgrounds}
              disableExpandOnClick={disableExpandOnClick}
              enableExpanding={enableExpanding}
              enableRowSelection={enableRowSelection}
              disableSelectOnClick={disableSelectOnClick}
              onRowClick={onRowClick}
              navigateTo={navigateTo}
            />
          ))}
      </>
    );
  }
  return (
    <CardRow
      key={row.id}
      color={
        alternateBackgrounds
          ? table
              .getRowModel()
              .rows.filter(row => row.depth === 0)
              .indexOf(row.getParentRows()[0] ?? row) %
              2 ===
            0
            ? 'white'
            : 'beige'
          : undefined
      }
      onClick={() => {
        if (!disableExpandOnClick && enableExpanding && row.getCanExpand()) row.toggleExpanded();
        else if (!disableSelectOnClick && enableRowSelection && row.getCanSelect())
          row.toggleSelected();

        onRowClick?.(row);
      }}
      to={to}
      isClickable={
        Boolean(onRowClick) ||
        (!disableSelectOnClick && enableRowSelection && row.getCanSelect()) ||
        (!disableExpandOnClick && enableExpanding && row.getCanExpand())
      }
      isSelected={row.getIsSelected() || row.getIsExpanded()}
      data-state={row.getIsSelected() && 'selected'}
    >
      {row.getVisibleCells().map(cell => {
        return (
          <CardCell key={cell.id}>
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </CardCell>
        );
      })}
    </CardRow>
  );
};
